import React, { PureComponent } from 'react';

import { Modal } from 'components/modal';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

class BulkActionErrorModal extends PureComponent {
  static propTypes = {
    bodyMsg: PropTypes.string,
    onClose: PropTypes.func,
    title: PropTypes.string
  };

  onClose = () => {
    const { onClose } = this.props;

    onClose && onClose();
  };

  render() {
    const { bodyMsg = '', title = '' } = this.props;

    return (
      <Modal onClose={this.onClose}>
        <Modal.Header>
          <h3 className="modal-title">{title}</h3>
        </Modal.Header>

        <Modal.Body>
          <div className="title__label users__list__bulk__actions__class-modal">
            <div>{bodyMsg}</div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="hot-button hot-button--primary hot-button--lg"
            onClick={this.onClose}
          >
            <I18n label="general.ok" />
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default BulkActionErrorModal;
